import React, { useState } from 'react';
import { ReactComponent as IconSearch } from '../../../Assets/Image/svg/search.svg';

function BootCampSearch({ className }) {
	const [inputFocus, setInputFocus] = useState(false);
	return (
		<div
			className={`${className} ${
				inputFocus ? 'focused' : ''
			} search__container form-control flex items-center border-solid border-light-prim border-[.1rem] rounded-16 hover:border-purple-dark  `}
		>
			<div
				className='
              w-full  h-71  rounded-16 overflow-hidden	bg-white-dark  pr-10 flex items-center'
			>
				<input
					type='text'
					placeholder='آموزش بازاریابی'
					className='input  h-full bg-white-dark  search__input  focus:outline-none text-[1.4rem]'
					onFocus={() => setInputFocus(true)}
					onBlur={() => setInputFocus(false)}
				/>
				<button className='search__button btn btn-square bg-white-dark  hover:bg-white-dark hover:border-0'>
					<IconSearch />
				</button>
			</div>
		</div>
	);
}
export default BootCampSearch;
